module.exports = __webpack_public_path__ + "static/media/Liang_Jingxi.dcd47e40.jpg";